// Page de vente publique : /
import { useEffect, useState } from 'react'
import { supabase } from './supabase'
import { CORAL, CHARBON, SABLE, Logo, LiensLegaux } from './actions'

const CONTACT = 'contact.jeebi@gmail.com'
const MAIL_DEMO = `mailto:${CONTACT}?subject=${encodeURIComponent('Démo Jeebi')}&body=${encodeURIComponent(
  "Bonjour,\n\nJe souhaite une démo de Jeebi pour mon commerce.\n\nNom du commerce :\nVille :\nTéléphone :\nMeilleur moment pour passer :\n"
)}`

const wrap = { maxWidth: 1080, margin: '0 auto', padding: '0 20px' }
const h2 = { fontSize: 'clamp(26px, 4vw, 36px)', fontWeight: 800, color: CHARBON, letterSpacing: -1, margin: '0 0 12px' }
const sousTitre = { fontSize: 17, color: '#666', lineHeight: 1.6, margin: 0 }

function Bouton({ href, children, secondaire }) {
  return (
    <a href={href} style={{
      display: 'inline-block', padding: '14px 22px', borderRadius: 12, fontSize: 16, fontWeight: 700,
      textDecoration: 'none', textAlign: 'center',
      background: secondaire ? 'transparent' : CORAL,
      color: secondaire ? CHARBON : '#fff',
      border: secondaire ? `1.5px solid ${CHARBON}` : 'none',
    }}>{children}</a>
  )
}

// Téléphone dessiné en CSS avec une carte de fidélité
function Telephone() {
  return (
    <div style={{ width: 260, maxWidth: '100%', margin: '0 auto', background: '#111', borderRadius: 40, padding: 12, boxShadow: '0 30px 60px rgba(28,28,28,0.25)' }}>
      <div style={{ background: '#f2f2f2', borderRadius: 30, padding: '36px 14px 22px', minHeight: 440 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 10, paddingLeft: 4 }}>Wallet</div>
        <div style={{ background: CHARBON, borderRadius: 16, padding: 16, color: '#fff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 15, fontWeight: 800 }}>Barbier Saint-Michel</div>
            <Logo size={22} />
          </div>
          <div style={{ fontSize: 11, opacity: 0.6, marginTop: 14 }}>Tampons</div>
          <div style={{ fontSize: 30, fontWeight: 800 }}>7/10</div>
          <div style={{ display: 'flex', gap: 4, margin: '8px 0 12px' }}>
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} style={{ flex: 1, height: 8, borderRadius: 3, background: i < 7 ? CORAL : 'rgba(255,255,255,0.15)' }} />
            ))}
          </div>
          <div style={{ fontSize: 11, opacity: 0.6 }}>Prochaine récompense</div>
          <div style={{ fontSize: 13, marginBottom: 14 }}>Coupe offerte — encore 3 passages</div>
          <div style={{ background: '#fff', borderRadius: 10, padding: 10, width: 96, height: 96, margin: '0 auto', boxSizing: 'border-box',
            backgroundImage: `repeating-linear-gradient(90deg, ${CHARBON} 0 6px, transparent 6px 12px), repeating-linear-gradient(0deg, ${CHARBON} 0 6px, transparent 6px 12px)`,
            backgroundBlendMode: 'multiply', backgroundClip: 'content-box' }} />
        </div>
        <div style={{ background: '#fff', borderRadius: 14, padding: '10px 12px', marginTop: 14, fontSize: 12, color: '#333', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <b>🎉 Plus que 3 passages</b><br />avant votre coupe offerte !
        </div>
      </div>
    </div>
  )
}

export default function Landing() {
  const [connecte, setConnecte] = useState(false)
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setConnecte(!!data.session))
  }, [])

  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', background: SABLE, color: '#444' }}>

      {/* En-tête */}
      <header style={{ ...wrap, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo size={34} />
          <span style={{ fontSize: 20, fontWeight: 800, color: CHARBON, letterSpacing: -1 }}>jeebi</span>
        </div>
        <a href="/app" style={{ fontSize: 14, fontWeight: 600, color: CHARBON, textDecoration: 'none' }}>
          {connecte ? 'Mon tableau de bord →' : 'Se connecter'}
        </a>
      </header>

      {/* Hero */}
      <section style={{ ...wrap, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 48, padding: '40px 20px 72px' }}>
        <div style={{ flex: '1 1 380px' }}>
          <div style={{ display: 'inline-block', background: '#fff', border: '1px solid #e8e0d8', borderRadius: 20, padding: '5px 12px', fontSize: 13, color: CORAL, fontWeight: 600, marginBottom: 18 }}>
            Pour les barbiers, cafés et commerces de quartier
          </div>
          <h1 style={{ fontSize: 'clamp(36px, 6vw, 56px)', lineHeight: 1.05, fontWeight: 850, color: CHARBON, letterSpacing: -2, margin: '0 0 18px' }}>
            La carte de fidélité qui ne se perd plus.
          </h1>
          <p style={{ ...sousTitre, fontSize: 19, marginBottom: 28 }}>
            Vos clients l'ajoutent à leur téléphone en 30 secondes, sans application.
            Vous tamponnez en scannant. Ils reviennent.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Bouton href={MAIL_DEMO}>Demander une démo gratuite</Bouton>
            <Bouton href="#tarifs" secondaire>Voir les tarifs</Bouton>
          </div>
          <div style={{ fontSize: 13, color: '#999', marginTop: 14 }}>
            On passe vous montrer en 10 minutes, dans votre boutique.{' '}
            <a href="/demo" style={{ color: CHARBON, fontWeight: 600 }}>Ou essayez le tableau de bord de démo →</a>
          </div>
        </div>
        <div style={{ flex: '1 1 280px' }}><Telephone /></div>
      </section>

      {/* Comment ça marche */}
      <section style={{ background: '#fff', padding: '72px 0' }}>
        <div style={wrap}>
          <h2 style={h2}>Comment ça marche</h2>
          <p style={{ ...sousTitre, marginBottom: 36 }}>Rien à installer pour vous, rien à télécharger pour vos clients.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20 }}>
            {[
              ['1', 'Une affiche au comptoir', 'On vous l\'installe : votre nom, votre récompense, un QR code.'],
              ['2', 'Le client scanne', 'Il entre son prénom et ajoute la carte à son téléphone. 30 secondes.'],
              ['3', 'Vous tamponnez', 'À chaque passage, vous scannez sa carte avec votre téléphone : +1.'],
              ['4', 'Il revient', 'La carte se met à jour toute seule et le prévient quand sa récompense est prête.'],
            ].map(([n, titre, texte]) => (
              <div key={n} style={{ background: SABLE, borderRadius: 16, padding: 22 }}>
                <div style={{ width: 34, height: 34, borderRadius: 10, background: CORAL, color: '#fff', fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>{n}</div>
                <div style={{ fontSize: 17, fontWeight: 700, color: CHARBON, marginBottom: 6 }}>{titre}</div>
                <div style={{ fontSize: 15, lineHeight: 1.5 }}>{texte}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bénéfices */}
      <section style={{ padding: '72px 0' }}>
        <div style={wrap}>
          <h2 style={h2}>Pourquoi passer au digital</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 20, marginTop: 28 }}>
            {[
              ['🗑️', 'Fini le carton perdu', 'La carte est dans le téléphone, que vos clients n\'oublient jamais.'],
              ['👀', 'Vous voyez qui revient', 'Visites par jour, clients fidèles, clients qui ne sont pas revenus depuis 30 jours.'],
              ['📱', 'Zéro matériel', 'Votre téléphone suffit. Pas de caisse à changer, pas de tablette à acheter.'],
              ['🔒', 'Données protégées', 'Hébergées dans l\'Union européenne. Elles vous appartiennent.'],
            ].map(([icone, titre, texte]) => (
              <div key={titre} style={{ background: '#fff', borderRadius: 16, padding: 22, border: '1px solid #e8e0d8' }}>
                <div style={{ fontSize: 28, marginBottom: 10 }}>{icone}</div>
                <div style={{ fontSize: 17, fontWeight: 700, color: CHARBON, marginBottom: 6 }}>{titre}</div>
                <div style={{ fontSize: 15, lineHeight: 1.5 }}>{texte}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tarifs */}
      <section id="tarifs" style={{ background: CHARBON, color: '#fff', padding: '72px 0' }}>
        <div style={wrap}>
          <h2 style={{ ...h2, color: '#fff' }}>Tarifs simples</h2>
          <p style={{ ...sousTitre, color: '#bbb', marginBottom: 32 }}>Sans engagement au mois. Résiliable par simple email.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: 20 }}>
            <div style={{ background: '#fff', color: CHARBON, borderRadius: 18, padding: 26, border: `3px solid ${CORAL}`, position: 'relative' }}>
              <div style={{ position: 'absolute', top: -13, left: 22, background: CORAL, color: '#fff', fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 20 }}>
                Offre fondateurs · 10 premiers commerces
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#888', marginTop: 6 }}>Mensuel</div>
              <div style={{ fontSize: 44, fontWeight: 850, letterSpacing: -2 }}>19 €<span style={{ fontSize: 16, fontWeight: 600, color: '#888' }}> /mois</span></div>
              <div style={{ fontSize: 15, marginBottom: 18 }}>ou <b>190 €/an</b> (2 mois offerts)</div>
              <div style={{ background: '#fff4f0', color: CORAL, borderRadius: 10, padding: '10px 12px', fontSize: 14, fontWeight: 700, marginBottom: 18 }}>
                Installation offerte <span style={{ textDecoration: 'line-through', fontWeight: 500, opacity: 0.7 }}>149 €</span>
              </div>
              {['Clients illimités', 'Carte Google Wallet à votre nom', 'Affiche QR imprimée et posée', 'Tableau de bord et statistiques', 'Prise en main sur place', 'Support par email et téléphone'].map(t => (
                <div key={t} style={{ fontSize: 15, padding: '5px 0' }}>✓ {t}</div>
              ))}
              <div style={{ marginTop: 20 }}><Bouton href={MAIL_DEMO}>Réserver ma place</Bouton></div>
            </div>
            <div style={{ borderRadius: 18, padding: 26, border: '1px solid #444' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#aaa' }}>Après l'offre fondateurs</div>
              <div style={{ fontSize: 44, fontWeight: 850, letterSpacing: -2 }}>19 €<span style={{ fontSize: 16, fontWeight: 600, color: '#aaa' }}> /mois</span></div>
              <div style={{ fontSize: 15, color: '#ccc', marginBottom: 18 }}>+ 149 € d'installation</div>
              <div style={{ fontSize: 15, color: '#ccc', lineHeight: 1.6 }}>
                Même service. L'installation comprend la configuration de votre carte, l'affiche
                imprimée et la formation de votre équipe.
              </div>
            </div>
          </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 18 }}>TVA non applicable, art. 293 B du CGI.</div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ padding: '72px 0' }}>
        <div style={{ ...wrap, maxWidth: 760 }}>
          <h2 style={h2}>Questions fréquentes</h2>
          {[
            ['Mes clients doivent-ils installer une application ?', 'Non. La carte s\'ajoute à Google Wallet, déjà présent sur les téléphones Android. Ils scannent, entrent leur prénom, c\'est fait.'],
            ['Et mes clients sur iPhone ?', 'L\'ajout à Apple Wallet arrive très prochainement. En attendant, ils s\'inscrivent de la même façon et vous les tamponnez depuis votre tableau de bord en cherchant leur prénom : aucun tampon n\'est perdu.'],
            ['Et ceux qui n\'ont pas de smartphone ?', 'Vous les ajoutez vous-même au tableau de bord avec leur prénom. Ils profitent de la même récompense.'],
            ['Je peux choisir ma récompense ?', 'Oui : le nombre de passages (de 3 à 30) et la récompense (coupe offerte, café offert, -20 %…). Modifiable à tout moment.'],
            ['Les données de mes clients m\'appartiennent ?', 'Oui. Elles sont hébergées dans l\'Union européenne, ne sont jamais revendues, et vous pouvez les récupérer à tout moment.'],
            ['Comment j\'arrête ?', 'Au mois, sans engagement : un email suffit, l\'arrêt prend effet à la fin du mois payé.'],
          ].map(([q, r]) => (
            <details key={q} style={{ background: '#fff', borderRadius: 12, padding: '16px 18px', marginBottom: 10, border: '1px solid #e8e0d8' }}>
              <summary style={{ fontSize: 16, fontWeight: 700, color: CHARBON, cursor: 'pointer' }}>{q}</summary>
              <p style={{ margin: '10px 0 0', lineHeight: 1.6 }}>{r}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Appel final */}
      <section style={{ background: CORAL, color: '#fff', padding: '64px 0', textAlign: 'center' }}>
        <div style={wrap}>
          <h2 style={{ ...h2, color: '#fff' }}>On passe vous montrer ?</h2>
          <p style={{ ...sousTitre, color: '#fff', opacity: 0.9, marginBottom: 26 }}>10 minutes dans votre boutique, sans engagement.</p>
          <a href={MAIL_DEMO} style={{ display: 'inline-block', background: '#fff', color: CORAL, padding: '14px 26px', borderRadius: 12, fontSize: 16, fontWeight: 800, textDecoration: 'none' }}>
            Demander une démo
          </a>
          <div style={{ fontSize: 14, marginTop: 14, opacity: 0.9 }}>ou écrivez à {CONTACT}</div>
        </div>
      </section>

      <footer style={{ padding: '28px 0' }}>
        <LiensLegaux />
        <div style={{ textAlign: 'center', fontSize: 11, color: '#aaa', marginTop: 8 }}>© 2026 Jeebi</div>
      </footer>
    </div>
  )
}
